import React from "react";
import { SliderItem } from "../../../../types";
import { CarouselSlideEditorTextSection } from "./CarouselSlideEditorTextSection";
import { CarouselSlideEditorImageSection } from "./CarouselSlideEditorImageSection";
import { CarouselSlideEditorButtonSection } from "./CarouselSlideEditorButtonSection";
import { CarouselSlideEditorLogoSection } from "./CarouselSlideEditorLogoSection";
import { CarouselSlideEditorAlignmentSection } from "./CarouselSlideEditorAlignmentSection";

interface SlideEditorFormProps {
    item: SliderItem;
    index: number;
    isRestricted: boolean;
    uploadingImages: { [key: string]: boolean };
    onImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFieldChange: (id: string, value: string | boolean | number) => void;
    onShowButtonChange: (enabled: boolean) => void;
    onPreviewViewModeChange: (mode: "desktop" | "mobile") => void;
}

export const CarouselSlideEditorImageForm: React.FC<SlideEditorFormProps> = ({
    item,
    index,
    isRestricted,
    uploadingImages,
    onImageUpload,
    onFieldChange,
    onShowButtonChange,
    onPreviewViewModeChange,
}) => {
    return (
        <div className="editSlide">
            <CarouselSlideEditorImageSection
                desktopSrc={item?.src}
                mobileSrc={item?.mobile}
                imageUrl={item?.imageUrl}
                imageUrlEnabled={!!(item as any)?.imageUrlEnabled}
                imageBrightness={item?.imageBrightness ?? 85}
                showButton={!!item?.showButton}
                isRestricted={isRestricted}
                isUploadingDesktop={!!uploadingImages?.src}
                isUploadingMobile={!!uploadingImages?.mobile}
                onImageUpload={onImageUpload}
                onFieldChange={onFieldChange}
            />

            <CarouselSlideEditorTextSection
                primaryText={item?.h2?.text}
                primaryColor={item?.h2?.color}
                secondaryText={item?.p?.text}
                secondaryColor={item?.p?.color}
                isRestricted={isRestricted}
                onFieldChange={onFieldChange}
            />

            <div className="twoCols">
                <CarouselSlideEditorLogoSection
                    logoSrc={item?.logo}
                    isRestricted={isRestricted}
                    isUploading={!!uploadingImages?.logo}
                    onImageUpload={onImageUpload}
                    onRemove={() => onFieldChange("logo", "")}
                />

                <CarouselSlideEditorButtonSection
                    buttonText={item?.a}
                    buttonUrl={item?.url}
                    buttonBackgroundColor={item?.buttonBackgroundColor || '#000000'}
                    buttonTextColor={item?.buttonTextColor || '#ffffff'}
                    showButton={!!item?.showButton}
                    imageUrlEnabled={!!(item as any)?.imageUrlEnabled}
                    isRestricted={isRestricted}
                    onFieldChange={onFieldChange}
                    onShowButtonChange={onShowButtonChange}
                />
            </div>

            <CarouselSlideEditorAlignmentSection
                horizontalAlignment={item?.horizontalAlignment || 'center'}
                verticalAlignment={item?.verticalAlignment || 'center'}
                useMobileAlignment={!!item?.useMobileAlignment}
                horizontalAlignmentMobile={item?.horizontalAlignmentMobile || item?.horizontalAlignment || 'center'}
                verticalAlignmentMobile={item?.verticalAlignmentMobile || item?.verticalAlignment || 'center'}
                onFieldChange={onFieldChange}
                onPreviewViewModeChange={onPreviewViewModeChange}
            />
        </div>
    );
};